<template>
<div class="app">
    <div class="header">
        <div class="icons-submenu">
            <div class="defaultheader icon-submenu" v-bind:class="{active: viewMode == 1}" @click="viewMode = 1">
                <div class="label">Umsatz Vorlagen</div>
            </div>
             <div class="defaultheader icon-submenu last" v-bind:class="{active: viewMode == 2}" @click="viewMode = 2">
                <div class="label">Umsätze</div>
            </div>
        </div>


            
        
    </div>
    <b-container fluid class="md-content scrollbar-container">


        <b-row style="margin-top: 12px;" v-if="viewMode == 1">
            <b-col>
                <storesalestemplateoverview></storesalestemplateoverview>
            </b-col>
        </b-row>
         <b-row style="margin-top: 12px;" v-if="viewMode == 2">
            <b-col>
                <storesalesoverview></storesalesoverview>
            </b-col>
        </b-row>
       
    </b-container>
</div>
</template>

<script>

import storesalestemplateoverview from '../storesalescontext/StoreSalesTemplateOverview.vue'
import storesalesoverview from '../storesalescontext/StoreSalesOverview.vue'



export default {
    components: {
      
        
        storesalestemplateoverview,
        storesalesoverview
    },
    name: 'PlanningMain',
    data() {
        return {
            viewMode: 1,
            loading: true,
        }
    },
    watch: {},
    props: {},
    created() {
        window.storesalesmain = this;
        var settings = this;
    },
    mounted(){
       
    },
    updated() {},
    destroyed() {},
    methods: {
        refresh(){
            
        },
    }
}
</script>